<template>
    <div>
      <h3 class="text-lg leading-6 font-medium text-gray-900">Choose a team: <span v-if="orderId">for order # {{ orderId }}</span></h3>
      <div v-if="errors && errors.message" class="flex items-center justify-center mb-2 px-2 py-1 bg-red-200 rounded text-red-700 text-sm">{{ errors.message }}</div>


      <div class="overflow-auto bg-gray-200 p-1">

        <div class="grid grid-cols-3 gap-1">
          <div v-for="team in teams" @click="team_id = team.id" class="bg-white p-2 shadow rounded cursor-pointer m-1 border-2 border-transparent hover:border-orange-500" :class="{'border-indigo-500': team_id === team.id}">
            <div class="text-sm">{{ team.name }}</div>
            <div class="text-xs">Assigned: {{ team.count }}</div>
            <div class="text-xs">Completed: {{ team.completed_count }}</div>
          </div>
        </div>
        <div v-if="errors && errors.team_id" class="text-red-600 text-sm py-1">{{ errors.team_id.join(', ') }}</div>
      </div>

      <div class="mt-4">

        <div v-if="errors && errors.delivery_date" class="text-red-600 text-sm py-1">{{ errors.delivery_date.join(', ') }}</div>
        <div class="inline-flex items-end">
          <date-input label="Delivery Date" v-model="delivery_date" class="mr-2"></date-input>
          <button :disabled="!team_id || !date" @click="emitEvent" class="btn-primary">Assign Selected Items</button>
        </div>
      </div>
    </div>
</template>

<script>
  import DateInput from '@/Shared/DateInput'
  export default {
    name: 'AssignModal',
    components: {DateInput},
    props: {
      selectedTeamId: Number,
      orderId: Number,
      date: String,
      errors: Object || null
    },

    mounted() {
      this.fetchTeams()
    },

    watch: {
      delivery_date: function () {
        this.fetchTeams()
      }
    },

    data() {
      return {
        teams: [],
        team_id: this.selectedTeamId || null,
        delivery_date: this.date,
      }
    },

    methods: {
      fetchTeams() {
        this.$http.get(this.route('ajax.delivery-teams.assigned-count', { date: this.delivery_date ? this.delivery_date : this.date })).then(response => {
          this.teams = response.data
        })
      },

      emitEvent() {

        const selectedTeam = this.teams.find((team) => {
          return team.id === this.team_id
        })

        this.$emit('assign', {
          team_id: this.team_id,
          name: selectedTeam.name || null,
          delivery_date: this.delivery_date
        })
      }
    }
  }
</script>

<style scoped>

</style>
